<template>
	<tr class="table__row">
		<template v-if="item.topic && item.topic != ''">
			<td class="table__data is-td">
				<template v-if="item.link && item.link != ''">
					<a v-bind:href="item.link">
					{{ item.topic}} {{ ' ' }}
					</a>
					<span v-if="item.subject && item.subject != ''">({{ item.subject}})</span>
				</template>
				<template v-if="item.desc && item.desc != ''">
					<br>
					{{ item.desc}}
				</template>
			</td>
			<td class="table__data is-td">
				<ExpertserviceExperts v-for="(expert, index) in item.experts" :key="index" :expert="expert"/>
			</td>
		</template>
	</tr>
</template>


<script>
import ExpertserviceExperts from "./ExpertserviceExperts.vue";
export default {
	name: 'ExpertserviceList',
	props: ["item"],
	components: {
		ExpertserviceExperts
	}
}
</script>
